import { FC } from 'react';
import { Link, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export interface GrecaptchaTypographyProps {
  className?: string;
}

export const GrecaptchaTypography: FC<GrecaptchaTypographyProps> = ({
  className,
}) => {
  const GrecaptchaComponent = styled('p')(({ theme }) => ({
    marginTop: '12px',
    color: '#7f7f7f',
    fontSize: '12px',
    lineHeight: '18px',
    textAlign: 'center',
    '& span': {
      display: 'block',
    },
    '& .MuiLink-root': {
      color: '#1565c0',
    },
  }));

  return (
    <Typography component={GrecaptchaComponent} className={className}>
      <span>このサイトはreCAPTCHAによって保護されており、</span>
      <span>
        Googleの
        <Link
          href="https://policies.google.com/privacy"
          target={'_blank'}
          rel={'noreferrer'}
        >
          プライバシーポリシー
        </Link>
        と
        <Link
          href="https://policies.google.com/terms"
          target={'_blank'}
          rel={'noreferrer'}
        >
          利用規約
        </Link>
        が適用されます。
      </span>
    </Typography>
  );
};
